import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { Button, Card, CardActions, CardContent, CardHeader, MenuItem, Popper, Stack, TextField } from "@mui/material";
import { QuestionMark } from "@mui/icons-material";
import { editCaseManClinicalReview } from "../../../../../services/caseManService/model/caseMan/CaseManagementSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";

function PsycologicalEvalEdit(){
    const dispatch = useAppDispatch();
    const caseManage = useAppSelector((state)=>state.caseManagement.caseManagement);
    const[popout, setPopout] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    return <React.Fragment>
        <Stack direction='row' alignSelf='center'>
        <TextField label='Psychological Evaluation' select defaultValue='Incomplete' sx={{width:'200px'}}
            value={caseManage.clinicalReview?.psycologicalEvaluation} onChange={(e)=>dispatch(editCaseManClinicalReview(new ReduxUpdate('psycologicalEvaluation',e.target.value)))}>
            <MenuItem value='Incomplete'>Incomplete</MenuItem>
            <MenuItem value='Pending'>Pending</MenuItem>
            <MenuItem value='Complete'>Complete</MenuItem>
            <MenuItem value='Not Required'>Not Required</MenuItem>
            <MenuItem value='Does Not Support'>Does Not Support</MenuItem>
        </TextField>
        <Button name='questions' startIcon={<QuestionMark/>} variant='text' onClick={(e)=>{setPopout(true);setAnchorEl(e.currentTarget)}}/>
        </Stack>
        <Popper open={popout} placement='right'  sx={{zIndex:100}} anchorEl={anchorEl}>
            <Card>
                <CardHeader title='Psychological Evaluation'/>
                <CardContent>
                <ul>
                    <li>This is only required for permanent placement of pain pump or neurostimulator devices.</li>
                </ul>
                </CardContent>
                <CardActions sx={{justifyContent:'center'}}><Button onClick={()=>setPopout(false)}>Close</Button></CardActions>
            </Card>
        </Popper>    
    </React.Fragment>
}
export {PsycologicalEvalEdit}